<div class="loading-window" [hidden]="!loading">
    <img *ngIf="!loadingFailed" src="assets/loading.gif" alt="loading" style="filter: invert(1) hue-rotate(148deg); margin-top: 3rem;">
    <div *ngIf="loadingFailed" >
        <img src="assets/loadingFailed.png" alt="loading failed" style="filter:invert(1);margin-top: 3rem;" /><br/><br/>
        <button nz-button nzType="default" (click)="reload()">Reload</button>
    </div>
</div>